import React, { Component } from "react";
import Modal from "../Modal";
import PropTypes from "prop-types";
import { Typography, Button, Spinner } from 'components';
import Dropdown from "../../../../components/Dropdown";
import { ATTENDED, UNATTENDED, RETURNED, PROFESSIONAL_NO_SHOW, PATIENT_NO_SHOW } from "../../../../settings/_scheduleStatusSettings";
import viewportHoc from "../../../../hoc/viewportHoc";
import { connect } from "react-redux";
import { setScheduleStatus, hideModal, cleanSchedules, getSchedules } from "../../../../redux/actions";
import AlertIcon from "components/AlertIcon";
import { Trans } from "@lingui/macro";
import Row from "components/Row";
import NotificationStep from "components/NotificationStep";

class ModalChangeScheduleStatus extends Component {

  dropdownProps = { placeholder: "Selecione um status" };

  constructor(props) {
    super(props);

    let currentStatus = props?.schedule?.status || '';

    this.state = {
      loading: false,
      sucess: false,
      statusSelected: currentStatus,
      availableStatus: this.getAvailableOptions(currentStatus)
    };
  }

  getAvailableOptions = (status) => {
    if (status === PROFESSIONAL_NO_SHOW || status === PATIENT_NO_SHOW)
      return [
        { name: "Profissional faltou", code: PROFESSIONAL_NO_SHOW },
        { name: "Paciente faltou", code: PATIENT_NO_SHOW },
        { name: "Realizada", code: ATTENDED },
        { name: "Devolvida", code: RETURNED }
      ];

    if (status === ATTENDED)
      return [
        { name: "Realizada", code: ATTENDED },
        { name: "Devolvida", code: RETURNED },
        { name: "Profissional faltou", code: PROFESSIONAL_NO_SHOW },
        { name: "Paciente faltou", code: PATIENT_NO_SHOW }
      ];

    return [
      { name: "Não realizada", code: UNATTENDED },
      { name: "Devolvida", code: RETURNED }
    ];
  }

  handleSubmitButton = () => {
    const { statusSelected } = this.state
    this.setState({ loading: true });

    const scheduleData = {
      statusCode: statusSelected,
      reasonCode: '',
      details: '',
    }
    this.props
      .onSetStatus(
        this.props.schedule.id,
        scheduleData
      )
      .then(() => {
        this.setState({ loading: false, sucess: true });
      })
      .catch(err => console.log(err));
  };

  closeWithSucess = async() => {
    const { filterData } = this.props;
    const dateTimeNow = toString(new Date());
    await this.props.onCleanSchedules();
    this.props.onGetSchedules({ 
      per_page: 10, 
      page: 1, 
      sort: "asc",
      query: filterData.text,
      start_date__gte: filterData.isFiltering ? filterData.startDate : dateTimeNow,
      end_date__lte: filterData.endDate,
      status_code: filterData.status
    });
    this.props.closeModal();
  }

  renderUpdateSuccess = () => {
    const notificationStepContent = (
      <Row justify="center">
        <Typography bold
          align="center"
          style={{ maxWidth: "33rem" }}
          type="heading2">
          <Trans>
            Modificação de status efetuada com sucesso!
          </Trans>
        </Typography>
      </Row>
    );

    return (
      <div className="ModalApproveValidity__Data">
        <NotificationStep
          buttonId="close-modal"
          btnText="Fechar"
          mainText={notificationStepContent}
          onSuccessClick={this.closeWithSucess}
          iconColor="#4ac326"
          iconName="Check"
          hasButton
        />
      </div>
    );
  }

  getStatusName = (code) => this.state.availableStatus.find(sts => sts.code === code).name;

  btnSubmitDisabled = () => {
    return this.state.statusSelected === this.props.schedule.status
  }

  render() {
    const { schedule } = this.props;
    const { statusSelected, availableStatus, loading, sucess } = this.state;

    return (
      <Modal
        btnId="confirm-change-status"
        modalTitle={sucess ? "" : "Mudar status da consulta"}
        closeModal={this.handleSubmitButton}
        extraClassName
      >
        {loading ?
          <div className="Container">
            <Spinner height="150px" />
          </div>
          :
          sucess ?
            this.renderUpdateSuccess()
            :
            <div className="Container">
              <div className="Container__data">
                <Typography align='center'>Psicólogo:</Typography>
                <Typography align='center' bold>{schedule.professionalName}</Typography>
                <Typography align='center'>CRP {schedule.professionalDocument}</Typography>
              </div>

              <div className="Container__data">
                <Typography align='center'>Paciente:</Typography>
                <Typography align='center' bold>{schedule.clientName}</Typography>
              </div>

              <div className="Container__data">
                <Typography align='center'>Data e horário:</Typography>
                <Typography align='center' bold>{`${schedule.date} às ${schedule.time}`}</Typography>
              </div>

              <div className="Container__dropdown">
                <Dropdown
                  onSelect={status => this.setState({ statusSelected: status })}
                  options={availableStatus}
                  placeholder={this.dropdownProps.placeholder}
                  preSelectedItem={statusSelected}
                />
                {
                  statusSelected !== schedule.status &&
                  <div className="Container__data">
                    <AlertIcon message={`Mudar o status da consulta para ${this.getStatusName(statusSelected)} é irreversível.\nTenha certeza antes de confirmar.`} />
                  </div>
                }
              </div>

              <Button
                disabled={this.btnSubmitDisabled()}
                text={(<Trans>Modificar status</Trans>)}
                id="send-medical-request"
                onButtonClick={this.handleSubmitButton}
              />
            </div>
        }
      </Modal>
    );
  }
}

ModalChangeScheduleStatus.propTypes = {
  schedule: PropTypes.object
};

const mapStateToProps = state => {
  return {
    filterData: state.filters
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSetStatus: (scheduleId, scheduleData) => dispatch(setScheduleStatus(scheduleId, scheduleData)),
    onCleanSchedules: () => dispatch(cleanSchedules()),
    onGetSchedules: (params) => dispatch(getSchedules(params)),
    closeModal: () => dispatch(hideModal()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(viewportHoc(ModalChangeScheduleStatus));
